import React, { useState, useCallback, useEffect } from 'react';
import { parse, stringify } from 'query-string';
import SearchFilter from '../_fields_v2/SearchFilter';
import { getSearchUtils } from '../../utils/query-utils';
import _ from 'lodash';

export default function PartnerFiltersDialog(props) {
  const { router } = props;

  const { location, history } = router;

  const [search, setSearch] = useState(parse(location.search));

  const debounceOnSubmit = useCallback(_.debounce(onSubmit, 250), []);

  useEffect(() => {
    setSearch(parse(location.search));
  }, [location.search]);

  const filterFields = {
    title: 'title',
    name: 'name',
    organization: 'organization'
  };

  function onSubmit(nextSearch) {
    history.push({
      pathname: location.pathname,
      search: stringify({
        ...nextSearch,
        page: 1
      })
    });
  }

  function onChange(nextSearch) {
    setSearch(nextSearch);
    debounceOnSubmit(nextSearch);
  }

  const searchUtils = getSearchUtils(search, onChange);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        <SearchFilter
          label="Offer title"
          tooltip="Find offers with a title that contains the phrase you type."
          value={searchUtils(filterFields.title).value}
          onChange={searchUtils(filterFields.title).onChangeValue}
        />
        <SearchFilter
          label="Partner name"
          tooltip="Find offers created by a partner whose first or last name matches one of the words you enter."
          value={searchUtils(filterFields.name).value}
          onChange={searchUtils(filterFields.name).onChangeValue}
        />
        <SearchFilter
          label="Partner organization"
          tooltip="Find offers affiliated with an organization whose name contains the phrase you type."
          value={searchUtils(filterFields.organization).value}
          onChange={searchUtils(filterFields.organization).onChangeValue}
        />
      </div>
    </>
  );
};
